import React from 'react';

/**
 * Rend un "markdown léger" en éléments React SÛRS (aucune injection HTML) :
 *  - gras : **texte**
 *  - liens : [texte](https://…)  (http/https uniquement)
 *  - puces : "- " en début de ligne → •
 *  - sauts de ligne conservés
 * Les emojis passent tels quels.
 */
const INLINE_RE = /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))/g;

function parseInline(line, keyPrefix) {
  const out = [];
  let last = 0;
  let k = 0;
  let m;
  INLINE_RE.lastIndex = 0;
  while ((m = INLINE_RE.exec(line)) !== null) {
    if (m.index > last) out.push(line.slice(last, m.index));
    if (m[1]) {
      out.push(React.createElement('strong', { key: `${keyPrefix}-b${k++}` }, m[2]));
    } else if (m[3]) {
      out.push(React.createElement('a', {
        key: `${keyPrefix}-l${k++}`,
        href: m[5],
        target: '_blank',
        rel: 'noopener noreferrer',
        style: { color: '#3b82f6', textDecoration: 'underline' }
      }, m[4]));
    }
    last = m.index + m[0].length;
  }
  if (last < line.length) out.push(line.slice(last));
  return out;
}

export function renderRichText(text) {
  const lines = String(text || '').split('\n');
  return lines.map((line, i) => {
    const l = line.replace(/^(\s*)-\s+/, '$1• ');
    return React.createElement(
      React.Fragment,
      { key: i },
      parseInline(l, i),
      i < lines.length - 1 ? React.createElement('br', { key: `br${i}` }) : null
    );
  });
}
